videojs.addLanguage('fr', {
  "Yes": "Oui",
  "No": "Non",
  "Nsp": "Je ne sais pas"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_skin_control_bar/dist/lang/fr.js
// module id = 547
// module chunks = 1